import {
  SET_TIME_ZONE,
  SET_INITIAL_DATE,
  SET_TIME_SLOT_SELECTED,
  SET_TOUCHED,
  SET_INITIAL_STATE,
  SET_PROJECT_ID,
} from './action-types';

export const setInitialState = () => async (dispatch) => {
  dispatch({ type: SET_INITIAL_STATE });
};

export const setProjectId = (projectId) => async (dispatch) => {
  dispatch({
    type: SET_PROJECT_ID,
    payload: projectId,
  });
};

export const setTimeZone = (timeZone) => async (dispatch) => {
  dispatch({
    type: SET_TIME_ZONE,
    payload: timeZone,
  });
};

export const setTouched = (touched) => async (dispatch) => {
  dispatch({
    type: SET_TOUCHED,
    payload: touched,
  });
};

export const setInitialDate = (initialDate) => async (dispatch) => {
  dispatch({
    type: SET_INITIAL_DATE,
    payload: initialDate,
  });
};

export const setTimeSlotSelected = (timeSlot) => async (dispatch) => {
  dispatch({
    type: SET_TIME_SLOT_SELECTED,
    payload: timeSlot,
  });
};
